var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-indicator",style:(_vm.alignStyle)},[_c('span',{staticClass:"status-indicator__dot",style:(_vm.dotStyle)}),_c('span',{staticClass:"status-indicator__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }